import * as angular from 'angular';

import { SearchSelectorItem } from './search-selector-item.component';
import { SearchSelectorComponent } from './search-selector.component';

export const SearchSelectorModule = angular
  .module('search-selector', [])
  .component('searchSelectorItem', SearchSelectorItem)
  .component('searchSelector', SearchSelectorComponent).name;
